

// import isWindows from './modules/_is-windows.js';
// import slider from './modules/_slider.js';
// import svg4everybody from 'svg4everybody'; // IE11用Hack必須 svg spriteのIE11ポリフィル
// import isNaN from './modules/_isNaN.js'; // IE11用Hack必須
// import isIE from './modules/_isIE.js';
// import pcSearch from './modules/_pc-search.js';
import scroll from './modules/_scroll.js';
import IntersectionObserver from './modules/_Intersection-Observer.js';
import isScroll from './modules/_is-scroll.js';
import menu from './modules/_menu.js';
// import megadrop from './modules/_megadrop.js';
// import pagetop from './modules/_pagetop.js';
// import instagram from './modules/_instagram.js';
// import imageSlider from './modules/_image-slider.js';
// import blurFix from './modules/_blur-fix.js';
// import currentNav from './modules/_currentNav.js';
// import modal from './modules/_modal.js';
// import accordion from './modules/_accordion.js';
// import appstorereview from './modules/_appstorereview.js';
// import spLocalnaviButton from './modules/_sp-localnavi-button.js';

import splideModal from './modules/_splide-modal.js';
import map from './modules/_map.js';
import mv from './modules/_mv.js';
import solutionCards from './modules/_solution-cards.js';
import slider from './modules/_slider.js';
// import cookie from './modules/_cookie.js';

// テキストのグラデーション
import gradText from './modules/_grad-text.js';

// 汎用無限ループスライダー
import loopSlider from './modules/_loop-slider.js';

// YouTube 動画埋め込み
import movie from './modules/_movie.js';

// 募集職種一覧（検索フィルタ / SPモーダル）
import jobs from './modules/_jobs.js';


// import isWebp from './modules/_is-webp.js';

// import tab from './modules/_tab.js';
// import telModal from './modules/_tel-modal.js';

// import topPosts from './modules/_top-posts.js';

// import loader from './modules/_loader.js';

// import narrowDown from './modules/_narrow-down.js';
// import postSpIndex from './modules/_post-sp-index.js';
// import tableIndexLink from './modules/_table-index-link.js';
// import video from './modules/_video.js';

// import refine from './modules/_refine.js';
// import pager from './modules/_pager.js';
// import currentNav from './modules/_currentNav.js';
// import home from './modules/_home.js';
// import skrollr from './modules/_skrollr.js';
// import form from './modules/_form.js';

// isWindows();
// slider();
// svg4everybody();  // svgのIE用ポリフィル
// isNaN();          // IE用ポリフィル
// isIE();           // IE判別
// pcSearch();
scroll();
IntersectionObserver();
isScroll();
menu();
slider();
// megadrop();
// pagetop();
// instagram();
// imageSlider()
// blurFix();
// currentNav();
// modal();
// accordion();
// appstorereview();
// spLocalnaviButton();


splideModal();
map();
mv();
solutionCards();
// cookie();
gradText();
loopSlider();
movie();
jobs();

// isWebp();

// telModal();


// topPosts();
// refine();
// pager();
// currentNav();

// home();



// loader();
// skrollr();
// tab();
// narrowDown();
// postSpIndex();
// tableIndexLink();
// video();
// form();

(($)=>{

  // jQuery
  "use strict";

})(jQuery);
